import Vue from 'vue'
import Vuex from 'vuex'
// import metaremote from '@/metaremote.js'

import moment from 'moment'
import numeral from 'numeral'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    app: 'SalesPaddy 2.8.6',
    active_tab:'',
    tabs:[],
    mandati:[],

    login: false,
    auth: {},
    connection: {
      myid: '',
      myid_token: '',
      mytokenizedid: '',
      mytoken: '',
      userdata: {},
      zona: '',
    },
    // google payload
    googleIdentity: {},
    // google decoded user
    user: {
      id: '',
      id_token: '',
      name: '',
      imageUrl: '',
      email: ''
    },
    multizona: false,
    position: {
      gps: false,
      lat: undefined,
      lng: undefined
    },
    showInactive: false,
    devices: [],
    deviceback:'',
    map: {},
    campagne: [],

    filtrocategoria: [true,true,true,true],
    filtrotipo:0,
    filtrotipi: [{checked:true},{checked:true},{checked:true},{checked:false},{checked:false},{checked:false},{checked:false}]
  },
  getters: {
    appname: function(state) { return state.app },
    connection: function(state) { return state.connection },
    logged: function(state) { return state.login },
    auth: function(state) { return state.auth },
    googleIdentity: function(state) { return state.googleIdentity },
    map: function(state) { return state.map },
    position: function(state) { return state.position },
    zona: function(state) { return state.connection.zona },

    filter: () =>  (v, type) => { 
      if (!v) return v;
      numeral.locale('it')
      switch(type) {
        case 'date':
          var d=new moment(v);
          return d.format('DD/MM/YYYY');
        case 'datetime':
          var dt=new moment(v);
          return dt.format('DD/MM/YYYY HH:mm');
        case 'number':
            return numeral(v).format('0,0')
        case 'decimal':
          return numeral(v).format('0,0.[0000]');
        case 'currency':
          return numeral(v).format('$ 0.00', Math.floor);
      }
    },
  },
  mutations: {
    SET_FILTROTIPO: function(state, payload)        { state.filtrotipo = payload; },
    SET_FILTROTIPI: function(state, payload)        { state.filtrotipi = payload; },
    SET_FILTROCATEGORIE: function(state, payload)   { state.filtrocategoria[payload] = !state.filtrocategoria[payload]; },

    SET_INACTIVE: function(state, payload) { state.showInactive = payload },
    SET_ZONA: function(state, payload)        { state.zona = payload; state.connection.zona = payload; },
    SET_CAMPAGNE: function(state, payload) { state.campagne=payload },
    SET_TABS: function(state, payload) { state.tabs=payload },
    SET_ACTIVE_TAB: function(state, payload) { state.active_tab=payload },
    SET_MANDATI: function(state, payload) { state.mandati=payload },
    SET_AUTH: function(state, payload)              { state.auth = payload; },

    SET_CONNECTION: function(state, payload)        {
      state.connection = payload;
      if (payload.userdata && payload.userdata.agentcodes && payload.userdata.agentcodes.length>0) {
        state.connection.zona = payload.userdata.agentcodes[0];
        if (payload.userdata.agentcodes.length>1) state.multizona=true;
      }
    },
    SET_CONNECTION_TOKEN: function(state, payload)  {
      state.connection.mytoken = payload.mytoken;
      state.connection.mytokenizedid = payload.mytokenizedid;
      state.connection.userdata = payload.userdata;

      if (payload.userdata && payload.userdata.agentcodes && payload.userdata.agentcodes.length>0) {
        state.connection.zona = payload.userdata.agentcodes[0];
        if (payload.userdata.agentcodes.length>1) state.multizona=true;
      }
    },
    SET_LOGIN: function(state, payload)             { state.login = payload; },
    SET_GOOGLE_IDENTITY: function(state, payload) {
      console.log('SET_GOOGLE_IDENTITY');
      localStorage.setItem('user', JSON.stringify(payload))

      state.googleIdentity = payload
      state.user.id_token  = payload.id_token
      state.user.id        = payload.sub
      state.user.name      = payload.name
      state.user.imageUrl  = payload.picture
      state.user.email     = payload.email
    },
    SET_MAP: function(state, payload)               { state.map = payload; },
    SET_POSITION: function(state, payload) {
      state.position.gps = true;
      state.position.lat = payload.lat;
      state.position.lng = payload.lng;
    },
    SET_DEVICES: function(state, payload) { state.devices=payload; },
    SET_DEVICE_BACK: function(state, payload) { state.deviceback=payload; },
  },
  modules: {
  },
  actions: {
    getDevices: function(context) {
      return new Promise(function(resolve, reject) {
        if (!navigator.mediaDevices) reject();
        navigator.mediaDevices.enumerateDevices().then(function(devices) {
          context.commit('SET_DEVICES', devices);
          var deviceId;
          devices.forEach(function(d) {
            if (d.kind == "videoinput" && d.label.toLowerCase().includes("back")) {
              context.commit('SET_DEVICE_BACK', deviceId);
            }
          });
          resolve();
        }).catch(function(err) {
          reject(err);
        })
      });
    },
    getPosition: function(context) {
      return new Promise(function(resolve, reject) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
            var pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };

            console.log('position ok');
            console.log(pos);
            context.commit('SET_POSITION', pos);
            resolve();
          }, function() {
            reject();
          });
        } else {
          reject();
        }
      });
    },
    showMapMsg: function(context, payload) {
      var pos = context.getters.position;
      var map = context.getters.map;
      console.log(pos);
      // eslint-disable-next-line no-undef
      this.infoWindow = new google.maps.InfoWindow;
      this.infoWindow.setPosition(payload.pos);
      this.infoWindow.setContent(payload.msg);
      this.infoWindow.open(map);
    },
    moveToMyPos: function(context) {
      var pos = context.getters.position;
      var map = context.getters.map;
      console.log(pos);
      map.setCenter(pos);
    },
    loadMandati: function(context) {
      console.log('loadMandati');
      context.commit('SET_MANDATI',[]);
    },
    signOut: function(context) {
      context.commit('SET_LOGIN', false)
      context.commit('SET_CONNECTION', {})
      context.commit('SET_CONNECTION_TOKEN', { mytoken: '', mytokenizedid: '', userdata: {} })
      context.commit('SET_GOOGLE_IDENTITY', {
        id_token: '',
        sub:      '',
        name:     '',
        picture:  '',
        email:    ''
      })

      localStorage.removeItem('user')

      console.log('User signed out.')
    },
    initmeta: function(context) {
      console.log('initmeta');
      context.dispatch('gettabs').then(function() {
        context.dispatch('getcampagne');
      })
    },
    gettabs: function(context) {
      var tabs=[
        { "order": 1, "name": "Home", "component": "Home", "path": "/" },
        { "order": 2, "name": "Lead", "component": "Leads", "path": "/lead"  },
        { "order": 3, "name": "Clienti", "component": "Clienti", "path": "/customer"  },
        { "order": 4, "name": "Situazione", "component": "Situazione", "path": "/situazione"  },
        { "order": 5, "name": "Ordini", "component": "Ordini", "path": "/ordini"  },
        { "order": 6, "name": "Fatture", "component": "Fatture", "path": "/fatture"  },
        { "order": 8, "name": "Cataloghi", "component": "Quotazioni", "path": "/quotazioni"  }
      ];

      if (context.state.multizona)
        tabs.push( { "order": 7, "name": "Analisi", "component": "Analisi", "path": "/analisi"  } );

      context.commit('SET_TABS', tabs );
      context.commit('SET_ACTIVE_TAB', tabs[0].name);
      /*
      return new Promise(function(resolve, reject) {
        console.log('gettabs');

        resolve();

        //metaremote.setSecret(context.getters.connection.secret);

        metaremote.get(context.getters.connection, 'tabs').then(function(res) {
          console.log('metaremote tabs get');
          console.log(res);
          if (res) {
            context.commit('SET_TABS', res );
            context.commit('SET_ACTIVE_TAB', res[0].name);
          } else {
            console.log('meta tabs problemi')
          }
          resolve();
        }).catch(function(err) {
          reject(err);
        });
      });
      */
    },
    getcampagne: function(context) {
      var campagne=[ 
                                                                                     "2027 PW",
        "2026 VF", "2026 RE", "2026 NA", "2026 MO", "2026 VP", "2026 VS", "2026 SC", "2026 PW", 
        "2025 VF", "2025 RE", "2025 NA", "2025 MO", "2025 VP", "2025 VS", "2025 SC", "2025 PW", 
        "2024 VF", "2024 RE", "2024 NA", "2024 MO",                       "2024 SC", "2024 PW" ];
      context.commit('SET_CAMPAGNE', campagne );
      /*
      return new Promise(function(resolve, reject) {
        console.log('getcampagne');
        //metaremote.setSecret(context.getters.connection.secret);
        metaremote.get(context.getters.connection, 'campagne').then(function(res) {
          console.log('metaremote campagne get');
          console.log(res);
          if (res) {
            context.commit('SET_CAMPAGNE', res );
          } else {
            console.log('meta campagne problemi')
          }
          resolve();
        }).catch(function(err) {
          reject(err);
        });
      });
      */
    }

  }
})
